import { useQuery, useMutation } from "@tanstack/react-query";
import { getUserList, modifyUserGrade } from "./service";

/**
 * admin/User
 */

export const useUserList = () => {
    return useQuery({
        queryKey: ['userList'],
        queryFn: getUserList,
    })
}

export const usePermission = () =>
    useMutation({
        mutationKey: ['permission'],
        mutationFn: ({ target_user_idx, grade }) => modifyUserGrade({ target_user_idx, grade }),
    })